'use strict';

/**
 *
 * @name: nnModules
 *
 */
import DirectiveTemplate from './nn-google-ad.directive.html';
import './nn-google-ad.directive.scss';
import _get from 'lodash.get'
import _debounce from 'lodash.debounce'

function NnGoogleAdDirective() {

  'ngInject';

  return {
    replace: true,
    restrict: 'EA',
    transclude: true,
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    link: function(scope, element) {

      /*
       *
       * @CONFIG
       *
       */

      scope.loaded = true;
      scope.show = false


      /*
       *
       * @PUBLIC
       *
       */

      scope.getAdUnitType = () => {
        return _get(scope.content(), 'jsonData.adType')
      }


      /*
       *
       * @PRIVATE
       *
       */

      function _getAdUnitName () {
        return _get(scope.content(), 'jsonData.adUnit')
      }

      function _getAdSizes () {
        return _get(scope.content(), 'jsonData.adSizes')
      }

      function _terminate () {
        scope.$destroy();
        element.remove();
      }

      const _initAd = _debounce(() => {
        const { post, lang } = scope.$root;

        if (lang === 'zh-cn') {
          return _terminate()
        }

        if (scope.slot) {
          googletag.destroySlots([scope.slot]);
          scope.slot = null
        }

        if (!_getAdUnitName() || !_getAdSizes()) {
          console.error('nn-google-ad.directive.js: Ad unit name/size is not defined in CMS')
          return
        }

        const isPost = Object.keys(post).length;

        const targeting = {
          keywords: isPost ? post.translations[lang].keywords.join() : '',
          articleid: isPost ? post.id : '',
          pageType: window.location.pathname.split('/')[1] || 'home',
          url: window.location.pathname
        }

        // LEAVE THAT CONSOLE.LOG IT'S USEFUL FOR ADS TEAM >>>
        console.log('>>> Google Ads Targeting <<<', targeting)
        // <<< LEAVE THAT CONSOLE.LOG IT'S USEFUL FOR ADS TEAM

        googletag.cmd.push(function() {
          scope.slot = googletag.defineSlot('/1060579/' + _getAdUnitName(), _getAdSizes(), 'div-gpt-ad-' + scope.$id).addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting('domain', [window.location.hostname === 'localhost' ? 'www.nowness.com' : window.location.hostname]);
          googletag.pubads().collapseEmptyDivs();
          googletag.enableServices();
          Object.entries(targeting).forEach(([key, value]) => {
            googletag.pubads().setTargeting(key, String(value));
          })
          googletag.pubads().addEventListener('slotRenderEnded', e => {
            if (e.isEmpty) {
              return
            }

            scope.$emit('googleAdLoaded');
          });
        });

        googletag.cmd.push(function() {
          googletag.display('div-gpt-ad-' + scope.$id);
        });

        scope.show = true
      }, 300);


      /**
       *
       * @INIT
       *
       */

      setTimeout(() => {
        _initAd();
      }, 1500)

      scope.$watch('$root.post', (newValue, oldValue) => {
        if (newValue.id === oldValue.id) return;

        _initAd();
      });
    }
  };
}

export default NnGoogleAdDirective;



// WEBPACK FOOTER //
// ./app/components/nn-modules/nn-google-ad/nn-google-ad.directive.js